/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./n1CardBody.vue?vue&type=template&id=dcd6b9cc&scoped=true"
import script from "./n1CardBody.vue?vue&type=script&lang=js"
export * from "./n1CardBody.vue?vue&type=script&lang=js"
import style0 from "./n1CardBody.vue?vue&type=style&index=0&id=dcd6b9cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd6b9cc",
  null
  
)

export default component.exports